<template>
  <b-row>
    <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
    <b-col
      md="2"
      sm="4"
      class="my-1"
    >
      <b-form-group
        class="mb-0"
      >
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          :options="pageOptions"
          class="w-50"
        />
      </b-form-group>
    </b-col>
    <b-col
      md="4"
      sm="8"
      class="my-1"
    >
      <!-- <b-form-group
        label="Sort"
        label-cols-sm="3"
        label-align-sm="right"
        label-size="sm"
        label-for="sortBySelect"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-select
            id="sortBySelect"
            v-model="sortBy"
            :options="sortOptions"
            class="w-75"
          >
            <template v-slot:first>
              <option value="">
                -- none --
              </option>
            </template>
          </b-form-select>
          <b-form-select
            v-model="sortDesc"
            size="sm"
            :disabled="!sortBy"
            class="w-25"
          >
            <option :value="false">
              {{$t('Asc')}}
            </option>
            <option :value="true">
              {{ $t('Desc') }}
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group> -->
    </b-col>
    <b-col
      md="6"
      class="my-1"
    >
      <b-form-group
        :label="$t('Filter')"
        label-cols-sm="3"
        label-align-sm="right"
        label-size="sm"
        label-for="filterInput"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            :placeholder="$t('Type to Search')"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
            {{$t('Clear')}}
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(id)="data">

                <b-form-checkbox  v-if="link_type=='deviceAttributes'"  :checked="selected_ids.includes(data.item.id)"   @change="change(data, $event)" >
                  {{ $t(data.item.description) }}


                </b-form-checkbox>

                   <b-form-checkbox  v-if="link_type!='deviceAttributes'"  :checked="selected_ids.includes(data.item.id)"   @change="change(data, $event)" >
                  {{ $t(data.item.name) }}


                </b-form-checkbox>


        </template>


      </b-table>
    </b-col>

    <b-col
      cols="12"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-0"
      />
    </b-col>

      <b-button @click="postData" type="button" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1">

          {{ $t('Save Changes') }}
        </b-button>


  </b-row>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton,BFormCheckbox
} from 'bootstrap-vue'
import useHelpers from '@/views/modules/useHelpers'
 import { OrbitSpinner } from 'epic-spinners'
import axios from '@/libs/axios'
const { toaster } = useHelpers(this)
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormCheckbox,
    OrbitSpinner
  },

//   setup(root){
// const { toaster } = useHelpers(root)
//   return {toaster}
//   },
  props:['items','fields','link_type','link_to_id','selected_ids'],
  data() {
    return {
      loading:false,
      listData:this.selected_ids,
      perPage: 25,
      pageOptions: [25,100,500],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
  watch: {
    selected_ids: function (newIds, oldIds) {
      this.listData = newIds
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
     change(data, value){
      const index = this.listData.indexOf(data.item.id);
      if (value && index === -1) this.listData.push(data.item.id)
      else this.listData.splice(index, 1)
    },
    postData(){
      let outData={}

      if(this.link_type == "deviceGeofences"){

        outData = {
          "type": this.link_type,
          "deviceId": this.link_to_id,
          "geofences": this.listData
        }
        }else if(this.link_type == "deviceDrivers"){
         outData = {
            "type": this.link_type,
            "deviceId": this.link_to_id,
            "drivers": this.listData
          }
        }else if(this.link_type == "driverDevices"){
           outData = {
            "type": this.link_type,
            "driverId": this.link_to_id,
            "devices": this.listData
          }
        }else if(this.link_type == "deviceAttributes"){
           outData = {
            "type": this.link_type,
            "deviceId": this.link_to_id,
            "attributes": this.listData
          }
        }

      this.loading = true;

      this.callApi(outData).then(res=>{
          this.$root.$bvToast.toast( this.$root.$i18n.t('successfly saved'),'success','Success', true);
      }).catch(reason => reason.status === 422 )
      .finally(() =>  this.loading = false)


    },
     callApi(data) {
    return new Promise((resolve, reject) => {
      axios.post(`links`, data).then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }


  },
}
</script>
